"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var delayedLoadingCover_1 = require("spry-react/LoadingCover/delayedLoadingCover");
var delayedLoadingBanner_1 = require("./delayedLoadingBanner");
require("./serialOperation.less");
var FeedbackType;
(function (FeedbackType) {
    FeedbackType[FeedbackType["FullPageSpinner"] = 0] = "FullPageSpinner";
    FeedbackType[FeedbackType["FullPageSpinnerImmediate"] = 1] = "FullPageSpinnerImmediate";
    FeedbackType[FeedbackType["LoadingBanner"] = 2] = "LoadingBanner";
    FeedbackType[FeedbackType["LoadingBannerImmediate"] = 3] = "LoadingBannerImmediate";
    FeedbackType[FeedbackType["None"] = 4] = "None";
})(FeedbackType = exports.FeedbackType || (exports.FeedbackType = {}));
// higher order function that returns a startSerialOperation function which will start an operation if no other operation is already pending
function buildSerialOperationStarter(getState, setState) {
    var stopSpinner = function () {
        setState({ isOperationPending: false, feedbackType: FeedbackType.None });
    };
    return function startSerialOperation(operation, feedbackType) {
        if (getState().isOperationPending)
            return null;
        setState({ isOperationPending: true, feedbackType: feedbackType });
        return operation().then(function (value) { stopSpinner(); return value; }, function (reason) { stopSpinner(); throw reason; });
    };
}
exports.buildSerialOperationStarter = buildSerialOperationStarter;
// controlled component that displays feedback UI to a react portal for the currently running serial operation
var SerialOperation = /** @class */ (function (_super) {
    __extends(SerialOperation, _super);
    function SerialOperation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SerialOperation.prototype.render = function () {
        if (this.props.state.feedbackType !== FeedbackType.None) {
            var portalEl = document.getElementById(this.props.portalId);
            if (!portalEl)
                throw "SerialOperation expected to find an element with id " + this.props.portalId;
            return ReactDOM.createPortal(this.renderSpinner(), portalEl);
        }
        else {
            return null;
        }
    };
    SerialOperation.prototype.renderSpinner = function () {
        var coverState = this.props.state.feedbackType === FeedbackType.FullPageSpinner ? delayedLoadingCover_1.ActiveState.Passive
            : this.props.state.feedbackType === FeedbackType.FullPageSpinnerImmediate ? delayedLoadingCover_1.ActiveState.Active
                : delayedLoadingCover_1.ActiveState.Off;
        var bannerState = this.props.state.feedbackType === FeedbackType.LoadingBanner ? delayedLoadingCover_1.ActiveState.Passive
            : this.props.state.feedbackType === FeedbackType.LoadingBannerImmediate ? delayedLoadingCover_1.ActiveState.Active
                : delayedLoadingCover_1.ActiveState.Off;
        return React.createElement(React.Fragment, null,
            React.createElement(delayedLoadingCover_1.DelayedLoadingCover, { active: coverState }),
            React.createElement(delayedLoadingBanner_1.DelayedLoadingBanner, { active: bannerState }));
    };
    return SerialOperation;
}(React.Component));
exports.SerialOperation = SerialOperation;
